<template>
  <div class="text-center">
    <v-dialog
      v-model="showMode"
      width="540"
    >
      <v-card>
        <v-card-title class="headline grey lighten-2">
          Изменение города
        </v-card-title>

        <v-card-text>
          <v-text-field
            v-model="model.title"
            :error="!name"
            :rules="nameRules"
            label="Город"
            required
          />
          <v-text-field
            v-model="model.latitude"
            label="Широта"
            required
            type="number"
          />
          <v-text-field
            v-model="model.longitude"
            label="Долгота"
            required
            type="number"
          />
        </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-btn
            text
            @click="$emit('onCloseEditModalShowMode', false)"
          >
            Отменить
          </v-btn>
          <v-spacer />
          <v-btn
            color="error"
            :disabled="!model.title"
            text
            @click="$emit('onCloseEditModalShowMode', true)"
          >
            Обновить
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>


export default {
  name: 'CityFormModal',
  props: {
    showMode: {
      type: Boolean,
      default: false
    },
    model: {
      type: Object,
    }
  },
  data () {
    return {
      name: null,
      nameRules: [
        (v) => !!v || 'Поле обязательное для заполнения',
      ],
    }
  },
  computed: {
    isValidNumber () {
      return /\d+/.test(this.model.title)
    },
  },
}
</script>
